import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Heading, HeroIcon, StepContainer } from '../common.js';
import { ExternalWalletCard, WalletCard, WalletCards } from '../WalletCard/WalletCard.js';
import { useCapsuleStore } from '../../stores/index.js';
export const LoginDoneStep = ({ onClose }) => {
    var _a;
    const capsule = useCapsuleStore(state => state.capsule);
    useEffect(() => {
        setTimeout(() => {
            onClose();
        }, 1600);
    }, []);
    return (_jsxs(StepContainer, { children: [_jsx(HeroIcon, { icon: "checkCircleFilled" }), _jsx(Heading, { variant: "headingS", weight: "bold", children: "Connected" }), _jsx(WalletCards, { children: capsule.isUsingExternalWallet() ? (_jsx(ExternalWalletCard, { address: (_a = capsule.currentExternalWalletAddresses) === null || _a === void 0 ? void 0 : _a[0] })) : (capsule.currentWalletIdsArray.map(([id, type]) => {
                    return _jsx(WalletCard, { id: id, type: type }, `${id}-${type}`);
                })) })] }));
};
